import React from "react";
import css from "./HierarchyView.module.css";
import {folder0} from "Assets";


export default function HierarchyView(props){
    const {hierarchy}=props;
    return (
        <div className={`${css.hierarchyview} ${props.className||""}`}>
            {hierarchy.map(entry=>(
                <div key={entry.name}>
                    <div className={css.header}>
                        {entry.children&&
                            <img alt=">" className={css.icon} src={folder0(mainColor)}/>
                        }
                        <span className={css.name}>{entry.name}</span>
                    </div>
                    {entry.children&&<HierarchyView className={css.subhierarchy} hierarchy={entry.children}/>}
                </div>
            ))}
        </div>
    )
}
